<template>

<div class="contentPool">
	<!-- page-heading -->
	<page-heading :show="true" pageTitle="CP-HEADLINE"></page-heading>

    <!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">

        <div class="columns">

            <div class="col-main">

                <tabs type="boxed" size="normal">

                  <!-- tab: BEITRÄGE -->
                  <tab-item :label="$t('CP-TAB-OVERVIEW')">

										<v-client-table ref="tblContentPool" name="tblContentPool" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="noFirstColumn">

											<!-- before table: FILTER OPTIONS -->
											<template slot="beforeTable">

												<!-- SEARCH -->
												<div class="control has-icon search is-pulled-left">
                            <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>

												<div class="is-pulled-right">
													<div class="columns filters">

														<div class="column">
															<form-input inputType="select" label="CP-FILTER-TYPES" minWidth="200px" :showLabelInOptions="true" :showLabel="false" :selectOptions="articleVariantTypes" v-model="filterArticleVariant"></form-input>
														</div>

														<div class="column">
															<form-input inputType="select" label="CP-FILTER-STATUS" minWidth="200px" :showLabelInOptions="true" :showLabel="false" :selectOptions="articleVariantStatus" v-model="filterArticleStatus"></form-input>
														</div>

														<div class="column">
															<form-input inputType="select" label="CP-FILTER-TOPICS" minWidth="220px" :showLabelInOptions="false" :showLabel="false" :selectOptions="articleTopics" v-model="filterArticleTopic"></form-input>
														</div>

														<div class="column">
															<form-input inputType="select" label="CP-FILTER-CATEGORIES" :showLabelInOptions="false" :showLabel="false" :selectOptions="articleCategories" v-model="filterArticleCategory"></form-input>
														</div>

														<div class="column">
															<span :class="[isFilterActive ? 'is-blue' : 'is-disabled', 'button reset-filter']" @click="resetFilters" :title="isFilterActive ? 'Klick um Filter zurückzusetzen' : ''">
																<span class="icon is-small"><i class="icon-ak-reset" aria-hidden="true"></i></span>
															</span>
														</div>

													</div>
												</div>

											</template>

											<!-- picture -->
											<template slot="asset" slot-scope="props">
												<div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImage(props.row.asset, true)" :key="props.row.id"></div>
											</template>

											<!-- publications -->
											<template slot="publications" slot-scope="props">

												<div class="channels is-clearfix">

													<div v-for="(channelType, index) in channelTypes" :key="props.row.id + '-' + channelType.id" class="channel">

														<template v-if="isPublished(props.row.publications[channelType.name])">

															<popover :width="200" trigger="hover" placement="top">

																<span class="icon is-enabled">
																	<i :class="channelIcon[channelType.name]"></i>
																</span>

																<span class="channelTypeCounter">
																	{{ getPublicationsCount(channelType, props.row.publications) }}
																</span>

																<div slot="content" class="channelEvents">

																	<div v-for="channelEvent in props.row.publications[channelType.name]" class="channelEvent">
																		<span class="title">{{ channelEvent.channel }}</span>
																		<template v-if="channelEvent.startDate == null">
																			<span class="date">-</span>
																		</template>
																		<template v-else>
																			<span class="date">{{ formatDate2(channelEvent.startDate, false) }}</span>
																		</template>
																	</div>

																</div>

															</popover>

														</template>

														<template v-else>

															<span class="icon">
																<i :class="channelIcon[channelType.name]"></i>
															</span>

															<span class="channelTypeCounter">
																{{ getPublicationsCount(channelType, props.row.publications) }}
															</span>

														</template>

													</div>

												</div>

											</template>

											<!-- updated -->
											<template slot="updated" slot-scope="props">
												{{ formatDate2(props.row.updated) }}
											</template>

										</v-client-table>

					        </tab-item>


					        <!-- tab: BEITRAGS ARCHIV -->
					        <tab-item :label="$t('CP-TAB-ARCHIVE')">

					            archiv ...

					        </tab-item>


                    <!-- tab: LOG -->
					<!--
                    <tab-item :label="$t('CP-TAB-LOG')">

						<template v-for="data in table.tblData">

							<timeline-item v-for="(changeLog, index) in data.changesLog" :key="index" :date="changeLog.loggedAt | formatDate" type="primary">

		                        <span class="author">
		                            <template v-if="changeLog.username">{{ changeLog.username }}</template><template v-else>{{ changeLog.user.username }}</template>:
		                        </span>

		                        <lang :labelKey="getEventDescription(changeLog)" :labelKey2="changeLog.label"></lang>

		                    </timeline-item>


						</template>
                    </tab-item>
					-->

                </tabs>

            </div>


            <div class="col-aside" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">

				<affix :offset="50">
					<custom-button type="blue" name="CP-BTN-CONTENT_ADD" icon="icon-ak-hinzufuegen" @click.native="newContent"></custom-button>
				</affix>

            </div>


        </div>

    </template>


</div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

  name: 'contentPool',

	components: {

	},

  data() {

		var self = this;

    return {

			isLoading: false,

			filterArticleTopic: null,
			filterArticleCategory: null,
			filterArticleVariant: null,
			filterArticleStatus: null,

			articleTopics: [],
			articleCategories: [],

			searchString: '',

			channelIcon: {
				NEWSLETTER: 'fa icon-ak-ch-email',
				ONLINE: 'fa icon-ak-ch-internet',
				DIGITAL_SIGNAGE: 'fa icon-ak-ch-digitalsignage',
				FACEBOOK: 'fa icon-ak-ch-socialmedia',
				PRINT: 'fa icon-ak-ch-print'
			},

			table: {

				tblColumns: ['asset', 'title', 'publications', 'updated'],
				tblData: [],
				tblOptions: {
					trackBy: 'id',
					uniqueKey: 'id',
					saveState: true,
					perPage: 25,
					orderBy: {
						ascending: false,
						column: 'updated'
					},

					// custom table headings
					headings: {

						asset: function(h) {
							return <lang labelKey="CP-TBL_HEADER-ASSET"></lang>
						},
						title: function(h) {
							return <lang labelKey="CP-TBL_HEADER-TITLE"></lang>
						},
						publications: function(h) {
							return <lang labelKey="CP-TBL_HEADER-PUBLICATIONS"></lang>
						},
						updated: function(h) {
							return <lang labelKey="CP-TBL_HEADER-UPDATED"></lang>
						},

					},

					sortable: ['title', 'updated'],
					sortIcon: {
              base:'fa',
              up:'fa-sort-up',
              down:'fa-sort-down',
              is:'fa-sort'
          },
					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'Aktuell sind keine zugewiesenen Beiträge für Sie vorhanden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					initFilters: {

            filter: {
							variant: self.$store.getters.getContentPoolFilter('variant') != null ? (self.$store.getters.getContentPoolFilter('variant')).name : null,
							topic: self.$store.getters.getContentPoolFilter('topic') != null ? (self.$store.getters.getContentPoolFilter('topic')).id : null,
							category: self.$store.getters.getContentPoolFilter('category') != null ? (self.$store.getters.getContentPoolFilter('category')).id : null,
							status: self.$store.getters.getContentPoolFilter('status') != null ? (self.$store.getters.getContentPoolFilter('status')).name : null,
						},

          },

					// custom filter functions
					customFilters: [

						{
						name: 'search',
							callback(row, string) {

								if(string == null || string == "") {
									return true;
								}

								string = string.toLowerCase();
								return row.title != null && row.title.toLowerCase().indexOf(string) >= 0
									|| row.variants.find((variant) =>
										variant.kicker != null && variant.kicker.toLowerCase().indexOf(string) >= 0 ||
										variant.headline != null && variant.headline.toLowerCase().indexOf(string) >= 0	||
										variant.teaserText != null && variant.teaserText.toLowerCase().indexOf(string) >= 0
									);

							}
						},

						{
						name: 'filter',

							callback(row, payload) {

								let category = payload.category;
								let topic = payload.topic;
								let variant = payload.variant;
								let status = payload.status;

								// reset
								if (status == null && category == null && topic == null && variant == null) {

									return true;

								}

								//var rowQualifies = false;

								if (category != null) {

									if (row.categories.length == 0 || row.categories.indexOf(category) == -1) {

										return false;

									}

								}

								if (topic != null) {

									if (row.topics == null || !row.topics.find(i => i.topic == topic)) {

										return false;

									}

								}

								if (status != null) {

									if (!row.variants.find(i => i.status.name == status)) {

										return false;

									}

								}

								if (variant != null) {

									if (!row.variants.find(i => i.type.name == variant && (status == null || i.status.name == status))) {

										return false;

									}

								}

								return true;

							}
						}

					],

				}
			}
        }

    },

	watch: {

		searchString(newVal, oldVal) {
      Event.$emit('vue-tables.tblContentPool.filter::search', newVal);
		},

		filterArticleTopic(newVal, oldVal) {
			this.$store.commit('setContentPoolFilter', { type: 'topic', value: newVal });
			Event.$emit('vue-tables.tblContentPool.filter::filter', {
				category: this.filterArticleCategory != null ? this.filterArticleCategory.id : null,
				topic: this.filterArticleTopic != null ? this.filterArticleTopic.id : null,
				variant: this.filterArticleVariant != null ? this.filterArticleVariant.name : null,
				status: this.filterArticleStatus != null ? this.filterArticleStatus.name : null
			});
		},

		filterArticleCategory(newVal, oldVal) {

			this.$store.commit('setContentPoolFilter', { type: 'category', value: newVal });

      Event.$emit('vue-tables.tblContentPool.filter::filter', {
				category: this.filterArticleCategory != null ? this.filterArticleCategory.id : null,
				topic: this.filterArticleTopic != null ? this.filterArticleTopic.id : null,
				variant: this.filterArticleVariant != null ? this.filterArticleVariant.name : null,
				status: this.filterArticleStatus != null ? this.filterArticleStatus.name : null
			});

		},

		filterArticleVariant(newVal, oldVal) {

			this.$store.commit('setContentPoolFilter', { type: 'variant', value: newVal });

      Event.$emit('vue-tables.tblContentPool.filter::filter', {
				category: this.filterArticleCategory != null ? this.filterArticleCategory.id : null,
				topic: this.filterArticleTopic != null ? this.filterArticleTopic.id : null,
				variant: this.filterArticleVariant != null ? this.filterArticleVariant.name : null,
				status: this.filterArticleStatus != null ? this.filterArticleStatus.name : null
			});

		},


		filterArticleStatus(newVal, oldVal) {

			this.$store.commit('setContentPoolFilter', { type: 'status', value: newVal });

      Event.$emit('vue-tables.tblContentPool.filter::filter', {
				category: this.filterArticleCategory != null ? this.filterArticleCategory.id : null,
				topic: this.filterArticleTopic != null ? this.filterArticleTopic.id : null,
				variant: this.filterArticleVariant != null ? this.filterArticleVariant.name : null,
				status: this.filterArticleStatus != null ? this.filterArticleStatus.name : null
			});

		}

	},


	computed: {

		channelTypes() {
      return this.$store.getters.getTermsByTaxonomy('CHANNEL_TYPES');
		},

		articleVariantStatus() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_STATUS');
		},

		articleVariantTypes() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_TYPES');
		},

		isFilterActive() {
			return this.filterArticleTopic != null || this.filterArticleCategory != null || this.filterArticleVariant != null || this.filterArticleStatus != null;
		}

	},


    created() {

			this.filterArticleTopic = this.$store.getters.getContentPoolFilter('topic');
			this.filterArticleCategory = this.$store.getters.getContentPoolFilter('category');
			this.filterArticleVariant = this.$store.getters.getContentPoolFilter('variant');
			this.filterArticleStatus = this.$store.getters.getContentPoolFilter('status');

			var self = this;
			this.fetchData().then(response => {
					self.isLoading = false;
	    });

		},


		mounted() {

			Event.$on('vue-tables.tblContentPool.row-click', function (data) {
				this.$router.push({ name: 'complatContentPoolContent', params: { 'contentID': data.row.id }  });
			}.bind(this));

		},


    methods: {

		resetFilters() {

			this.filterArticleTopic = null;
			this.filterArticleCategory = null;
			this.filterArticleVariant = null;
			this.filterArticleStatus = null;

		},

		isPublished(channel) {

			var currentDate = new Date();

			for(let i in channel) {

				if(channel[i].startDate != null && new Date(channel[i].startDate) <= currentDate) {
					return true;
				}

			}

			return false;

		},


		/*isPublished2(channel, variant) {

			if(typeof channel == 'undefined') {
				return false;
			}

			for(let i in channel) {

				let channelName = (channel[i].channel.split(' ').join('_')).toUpperCase();


				if(variant == 'NEWSLETTER' || variant == 'TEASER_INTERNAL') {

					if(variant == 'TEASER_INTERNAL') {
						return channelName == 'NEWSLETTER_ERFOLGSNEWS';
					} else {
						if(channelName != 'NEWSLETTER_ERFOLGSNEWS' && channelName.substr(0, 10) == variant) {
							return true;
						}
					}

				}
				else if (variant == 'HERBA_IMPULSE_PRINT') {

					if(channelName == 'HERBA_IMPULSE') {
						channelName = 'HERBA_IMPULSE_PRINT';
					}

				}

				if(channelName == variant) {
					return true;
				}

			}

			return false;

		},*/

		getPublicationsCount(channelType, publications) {

			return typeof publications[channelType.name] != 'undefined'	? publications[channelType.name].length : 0;

		},

		getImage(asset, thumb=false) {

			if(asset == null) {
				return '';
			}

			return this.$config.assets + asset.asset.path + '/' + (thumb == true ? 'thumb/' : '' ) + asset.asset.filename;

		},

		newContent() {

			this.$router.push({ name: 'complatContentPoolContentNew' });

		},


		search() {

			var self = this;

      setTimeout(function() {
          Event.$emit('vue-tables.tblContentPool.filter::search', self.searchString );
      }, 10);

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			return new Promise(function(resolve, reject) {

				function getArticles() {
					return self.axios.get(self.$config.api + 'article?loadChangesLog=0');
				}
				function getArticleCategories() {
					return self.axios.get(self.$config.api + 'articleCategory');
				}
				function getArticleTopics() {
					return self.axios.get(self.$config.api + 'articleTopic');
				}

				self.axios.all([getArticles(), getArticleCategories(), getArticleTopics()])
					.then(self.axios.spread(function (resArticles, resArticleCategories, resTopics) {


						// if user is of type "Administrator", "Herba Chefradaktion" or "Herba Leitung", he has full access ...
						if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Herba Leitung'].indexOf(self.activeUser.userRole.name) > -1) {

							self.table.tblData = resArticles.data.article;

						// otherweise the user is allowed to see his own posts only ...
						} else {

							resArticles.data.article.forEach((article) => {
								article.variants.forEach((variant) => {

									if(variant.assignee == self.activeUser.id) {

										// make sure the article is not in self.table.tblData yet
										if(!self.table.tblData.some((i) => { return i.id == article.id })) {
											self.table.tblData.push(article);
										}

									}

								})
							})

						}

						self.articleTopics = resTopics.data.articleTopic;
	                    self.articleCategories = resArticleCategories.data.articleCategory;

						resolve();

					})).catch(function(error) {
						console.log("ERROR: ", error);
					});

			});

		},

		/*
		fetchNewslettersOUT(article, variantId) {

            var self = this;

            return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements,newsletter.channel,newsletterElement.articleVariant,newsletter.status&filters[status.name]=SENT&orderBy=sendDate%20DESC&filters%5belements.articleVariant%5d='+variantId)
                .then(response => {

					article.publications.NEWSLETTER = [];

                    response.data.newsletter.forEach(newsletter => {

                        let obj = {
							channel: newsletter.channel.name,
                            startDate: newsletter.sendDate
                        }

						article.publications.NEWSLETTER.push(obj);

                    })

                    return response.data.newsletter;

            });

        },
		*/

	}

}

</script>


<style scoped>

	/* CHANNELS */
	.contentPool .channels {

	}
	.contentPool .channels .channel {
		text-align:center;
		float: left;
	}

	.contentPool .channels .channel .icon {
		display: inline-block;
		color: #ccc;
		font-size: 16px;
		width: 30px;
		margin-right: 0;
	}
	.contentPool .channels .channel .icon {
		color: #ccc;
		font-size: 18px;
		transition: all .3s ease;
	}
	.contentPool .channels .channel .icon.is-enabled {
		color: #45a7d6;
	}
	.contentPool .channels .channel:hover .icon {
		color: #000;
	}
	.contentPool .channels .channel .channelTypeCounter {
		display: block;
		text-align: center;
		font-size: 9px;
	}


	.channelEvents .channelEvent {
		font-size: 8px;
		padding: 3px 2px;
	}
	.channelEvents .channelEvent .title {
		display: block;
		font-size: 12px !important;
		padding: 0;
		margin: 0 0 3px 0;
	}
	.channelEvents .channelEvent .date {
		display: block;
		font-size: 10px;
		color: #aaa;
	}
	.channelEvents .channelEvent:not(:last-child) {
		border-bottom: 1px solid #eee;
	}

	/* needed for multiselect overlay fix */
	>>> .tabs,
	>>> .tabs .tab-content {
		overflow: visible;
	}

</style>

<style>

	.contentPool table {
		table-layout: fixed;
	}
	.contentPool th:first-child {
		width: 120px;
	}

	.contentPool th:nth-last-child(2) {
		width: 240px;
		min-width: 220px;
	}
	.contentPool th:last-child {
		width: 180px;
	}

	.contentPool .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: cover;
		width: 80px;
		height: 60px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.contentPool .imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}
	.contentPool .imgWrapper[lazy=error]  {
		background-image: none !important;
	}
</style>
